import { render, staticRenderFns } from "./addNew.vue?vue&type=template&id=639c45af"
import script from "./addNew.vue?vue&type=script&lang=js"
export * from "./addNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports